import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const handleBookAppointment = () => {
    navigate('/appointment');
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass-header" data-testid="main-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
            <img
              src="https://customer-assets-agu9un31.emergentagent.net/job_wealth-journey-147/artifacts/xh3bugve_image.png"
              alt="Impetus Investment Services Logo"
              className="h-14 w-auto object-contain"
            />
            <div className="hidden md:flex flex-col">
              <h1 className="text-lg lg:text-xl font-heading font-bold text-[#A0451E] leading-tight tracking-wide">
                IMPETUS INVESTMENT SERVICES
              </h1>
              <p className="text-xs text-[#D97706] font-body italic">Bridge to Financial Wellness</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <Link to="/" className="text-[#4A4A4A] hover:text-[#A0451E] font-body transition" data-testid="nav-home">
              Home
            </Link>
            <Link to="/about" className="text-[#4A4A4A] hover:text-[#A0451E] font-body transition" data-testid="nav-about">
              About Us
            </Link>
            <Link to="/services" className="text-[#4A4A4A] hover:text-[#A0451E] font-body transition" data-testid="nav-services">
              Services
            </Link>
            <Link to="/education" className="text-[#4A4A4A] hover:text-[#A0451E] font-body transition" data-testid="nav-education">
              Investor Education
            </Link>
            <Link to="/resources" className="text-[#4A4A4A] hover:text-[#A0451E] font-body transition" data-testid="nav-resources">
              Resources
            </Link>
            <Link to="/faq" className="text-[#4A4A4A] hover:text-[#A0451E] font-body transition" data-testid="nav-faq">
              FAQs
            </Link>
            <Link to="/contact" className="text-[#4A4A4A] hover:text-[#A0451E] font-body transition" data-testid="nav-contact">
              Contact Us
            </Link>
            <button
              onClick={handleBookAppointment}
              className="btn-primary"
              data-testid="book-appointment-header-btn"
            >
              Book Appointment
            </button>
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={toggleMenu}
            className="lg:hidden text-[#A0451E] p-2"
            data-testid="mobile-menu-toggle"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200" data-testid="mobile-menu">
            <div className="flex flex-col space-y-4">
              <Link to="/" className="text-[#4A4A4A] hover:text-[#A0451E] font-body" onClick={toggleMenu}>
                Home
              </Link>
              <Link to="/about" className="text-[#4A4A4A] hover:text-[#A0451E] font-body" onClick={toggleMenu}>
                About Us
              </Link>
              <Link to="/services" className="text-[#4A4A4A] hover:text-[#A0451E] font-body" onClick={toggleMenu}>
                Services
              </Link>
              <Link to="/education" className="text-[#4A4A4A] hover:text-[#A0451E] font-body" onClick={toggleMenu}>
                Investor Education
              </Link>
              <Link to="/resources" className="text-[#4A4A4A] hover:text-[#A0451E] font-body" onClick={toggleMenu}>
                Resources
              </Link>
              <Link to="/faq" className="text-[#4A4A4A] hover:text-[#A0451E] font-body" onClick={toggleMenu}>
                FAQs
              </Link>
              <Link to="/contact" className="text-[#4A4A4A] hover:text-[#A0451E] font-body" onClick={toggleMenu}>
                Contact Us
              </Link>
              <button
                onClick={() => {
                  handleBookAppointment();
                  toggleMenu();
                }}
                className="btn-primary w-full"
              >
                Book Appointment
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;